export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [// 支付结算管理-上游电商结算对账-业务对账
  {
    path: 'ecUpSettlementList',
    name: 'ecUpSettlementList',
    meta: {
      title: '上游电商业务对账',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecUpSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecUpSettlementMenu/ecUpSettlementList/ecUpSettlementList');
    }
  }, // 支付结算管理-上游电商结算对账-结算单确认页
  {
    path: 'ecUpConfirmStatement',
    name: 'ecUpConfirmStatement',
    meta: {
      title: '结算单确认页',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecUpSettlementMenu/ecUpSettlementList/ecUpConfirmStatement');
    }
  }, // 支付结算管理-上游电商结算对账-结算单列表页
  {
    path: 'ecUpBillList',
    name: 'ecUpBillList',
    meta: {
      title: '上游电商结算单',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecUpBillList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecUpSettlementMenu/ecUpBillList/ecUpBillList');
    }
  }, // 支付结算管理-上游电商结算对账-结算单确认对账结果
  {
    path: 'ecUpStatementConfirmReconciliation',
    name: 'ecUpStatementConfirmReconciliation',
    meta: {
      title: '结算单确认对账结果',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecUpSettlementMenu/ecUpBillList/ecUpStatementConfirmReconciliation');
    }
  }, // 支付结算管理-上游电商结算对账-结算单发票核对签收页
  {
    path: 'ecUpReceiptOfStatement',
    name: 'ecUpReceiptOfStatement',
    meta: {
      title: '结算单发票核对签收页',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecUpSettlementMenu/ecUpBillList/ecUpReceiptOfStatement');
    }
  }, // 支付结算管理-上游电商结算对账-发票预览下载
  {
    path: 'ecUpInvoiceDownload',
    name: 'ecUpInvoiceDownload',
    meta: {
      title: '发票预览下载',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecUpSettlementMenu/ecUpBillList/ecUpInvoiceDownload');
    }
  }, // 支付结算管理-上游电商结算对账-结算单详情
  {
    path: 'ecUpStatementDetails',
    name: 'ecUpStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecUpSettlementMenu/ecUpBillList/ecUpStatementDetails');
    }
  }, // 支付结算管理-上游电商结算对账-发票物流详情
  {
    path: 'ecUpInvoiceLogisticsDetails',
    name: 'ecUpInvoiceLogisticsDetails',
    meta: {
      title: '发票物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecUpSettlementMenu/ecUpBillList/ecUpInvoiceLogisticsDetails');
    }
  }, // 支付结算管理-上游协议结算对账-业务对账
  {
    path: 'agrUpSettlementList',
    name: 'agrUpSettlementList',
    meta: {
      title: '上游协议业务对账',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrUpSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrUpSettlementMenu/agrUpSettlementList/agrUpSettlementList');
    }
  }, // 支付结算管理-上游协议结算对账-结算单确认页
  {
    path: 'agrConfirmStatement',
    name: 'agrConfirmStatement',
    meta: {
      title: '结算单确认页',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrUpSettlementMenu/agrUpSettlementList/agrConfirmStatement');
    }
  }, // 支付结算管理-上游协议结算对账-结算单确认页 提交成功页
  {
    path: 'agrConfirmStatementSubmSucce',
    name: 'agrConfirmStatementSubmSucce',
    meta: {
      title: '结算单确认页',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrUpSettlementMenu/agrUpSettlementList/agrConfirmStatementSubmSucce');
    }
  }, // 支付结算管理-上游协议结算对账-结算单列表页
  {
    path: 'agrBillList',
    name: 'agrBillList',
    meta: {
      title: '上游协议结算单',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrBillList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrUpSettlementMenu/agrBillList/agrBillList');
    }
  }, // 支付结算管理-上游协议结算对账-结算单确认对账结果
  {
    path: 'agrStatementConfirmReconciliation',
    name: 'agrStatementConfirmReconciliation',
    meta: {
      title: '结算单确认对账结果',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrUpSettlementMenu/agrBillList/agrStatementConfirmReconciliation');
    }
  }, // 支付结算管理-上游协议结算对账-结算单发票核对签收页
  {
    path: 'agrReceiptOfStatement',
    name: 'agrReceiptOfStatement',
    meta: {
      title: '结算单发票核对签收页',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrUpSettlementMenu/agrBillList/agrReceiptOfStatement');
    }
  }, // 支付结算管理-上游协议结算对账-发票预览下载
  {
    path: 'agrInvoiceDownload',
    name: 'agrInvoiceDownload',
    meta: {
      title: '发票预览下载',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrUpSettlementMenu/agrBillList/agrInvoiceDownload');
    }
  }, // 支付结算管理-上游协议结算对账-结算单详情
  {
    path: 'agrStatementDetails',
    name: 'agrStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrUpSettlementMenu/agrBillList/agrStatementDetails');
    }
  }, // 支付结算管理-上游协议结算对账-发票物流详情
  {
    path: 'agrInvoiceLogisticsDetails',
    name: 'agrInvoiceLogisticsDetails',
    meta: {
      title: '发票物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrUpSettlementMenu/agrBillList/agrInvoiceLogisticsDetails');
    }
  }, // 支付结算管理-账户管理-账户管理列表页（运营单位）
  {
    path: 'payAccountManage',
    name: 'payAccountManage',
    meta: {
      title: '账户管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['payAccountManage']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payAccountMenu/payAccountManage/payAccountManage');
    }
  }, // 支付结算管理-账户管理-账户管理新增
  {
    path: 'payAccountAdd',
    name: 'payAccountAdd',
    meta: {
      title: '账户管理新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payAccountMenu/payAccountManage/payAccountAdd');
    }
  }, // 支付结算管理-账户管理-账户详情页
  {
    path: 'payAccountDetail',
    name: 'payAccountDetail',
    meta: {
      title: '账户详情页',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payAccountMenu/payAccountManage/payAccountDetail');
    }
  }, // 支付结算管理-上游无协议结算对账-业务对账
  {
    path: 'unagrUpSettlementList',
    name: 'unagrUpSettlementList',
    meta: {
      title: '上游无协议业务对账',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrUpSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrUpSettlementMenu/unagrUpSettlementList/unagrUpSettlementList');
    }
  }, // 支付结算管理-上游无协议结算对账-结算单确认
  {
    path: 'unagrConfirmStatement',
    name: 'unagrConfirmStatement',
    meta: {
      title: '结算单确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrUpSettlementMenu/unagrUpSettlementList/unagrConfirmStatement');
    }
  }, // 支付结算管理-上游无协议结算对账-结算单列表页
  {
    path: 'unagrBillList',
    name: 'unagrBillList',
    meta: {
      title: '上游无协议结算单',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrBillList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrUpSettlementMenu/unagrBillList/unagrBillList');
    }
  }, // 支付结算管理-上游无协议结算对账-结算单确认对账结果
  {
    path: 'unagrStatementConfirmReconciliation',
    name: 'unagrStatementConfirmReconciliation',
    meta: {
      title: '结算单确认对账结果',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrUpSettlementMenu/unagrBillList/unagrStatementConfirmReconciliation');
    }
  }, // 支付结算管理-上游无协议结算对账-结算单发票核对签收页
  {
    path: 'unagrReceiptOfStatement',
    name: 'unagrReceiptOfStatement',
    meta: {
      title: '结算单发票核对签收页',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrUpSettlementMenu/unagrBillList/unagrReceiptOfStatement');
    }
  }, // 支付结算管理-上游无协议结算对账-发票预览下载
  {
    path: 'unagrInvoiceDownload',
    name: 'unagrInvoiceDownload',
    meta: {
      title: '发票预览下载',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrUpSettlementMenu/unagrBillList/unagrInvoiceDownload');
    }
  }, // 支付结算管理-上游无协议结算对账-结算单详情
  {
    path: 'unagrStatementDetails',
    name: 'unagrStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrUpSettlementMenu/unagrBillList/unagrStatementDetails');
    }
  }, // 支付结算管理-上游wu协议结算对账-发票物流详情
  {
    path: 'unagrInvoiceLogisticsDetails',
    name: 'unagrInvoiceLogisticsDetails',
    meta: {
      title: '发票物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrUpSettlementMenu/unagrBillList/unagrInvoiceLogisticsDetails');
    }
  }, // 支付结算管理-下游协议结算对账-业务对账
  {
    path: 'agrDownSettlementList',
    name: 'agrDownSettlementList',
    meta: {
      title: '下游协议业务对账',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrDownSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrDownSettlementMenu/agrDownSettlementList/agrDownSettlementList');
    }
  }, // 支付结算管理-下游协议结算对账-结算单确认
  {
    path: 'agrDownConfirmStatement',
    name: 'agrDownConfirmStatement',
    meta: {
      title: '下游结算单确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrDownSettlementMenu/agrDownSettlementList/agrDownConfirmStatement');
    }
  }, // 支付结算管理-下游协议结算对账-结算单列表页
  {
    path: 'agrDownBillList',
    name: 'agrDownBillList',
    meta: {
      title: '下游协议结算单',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrDownBillList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrDownSettlementMenu/agrDownBillList/agrDownBillList');
    }
  }, // 支付结算管理-下游协议结算对账-发票邮寄信息
  {
    path: 'agrDownMailingInformation',
    name: 'agrDownMailingInformation',
    meta: {
      title: '发票邮寄信息',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrDownSettlementMenu/agrDownBillList/agrDownMailingInformation');
    }
  }, // 支付结算管理-下游协议结算对账-发票预览下载
  {
    path: 'agrDownInvoiceDownload',
    name: 'agrDownInvoiceDownload',
    meta: {
      title: '发票预览下载',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrDownSettlementMenu/agrDownBillList/agrDownInvoiceDownload');
    }
  }, // 支付结算管理-下游协议结算对账-结算单详情
  {
    path: 'agrDownStatementDetails',
    name: 'agrDownStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrDownSettlementMenu/agrDownBillList/agrDownStatementDetails');
    }
  }, // 支付结算管理-下游协议结算对账-发票物流详情
  {
    path: 'agrDownInvoiceLogisticsDetails',
    name: 'agrDownInvoiceLogisticsDetails',
    meta: {
      title: '发票物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrDownSettlementMenu/agrDownBillList/agrDownInvoiceLogisticsDetails');
    }
  }, // 支付结算管理-下游电商结算对账-业务对账
  {
    path: 'ecDownSettlementList',
    name: 'ecDownSettlementList',
    meta: {
      title: '下游电商业务对账',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecDownSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecDownSettlementMenu/ecDownSettlementList/ecDownSettlementList');
    }
  }, // 支付结算管理-下游电商结算对账-结算单确认
  {
    path: 'ecDownConfirmStatement',
    name: 'ecDownConfirmStatement',
    meta: {
      title: '下游电商结算单确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecDownSettlementMenu/ecDownSettlementList/ecDownConfirmStatement');
    }
  }, // 支付结算管理-下游电商结算对账-结算单列表页
  {
    path: 'ecDownBillList',
    name: 'ecDownBillList',
    meta: {
      title: '下游电商结算单',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecDownBillList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecDownSettlementMenu/ecDownBillList/ecDownBillList');
    }
  }, // 支付结算管理-下游电商结算对账-发票邮寄信息
  {
    path: 'ecDownMailingInformation',
    name: 'ecDownMailingInformation',
    meta: {
      title: '发票邮寄信息',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecDownSettlementMenu/ecDownBillList/ecDownMailingInformation');
    }
  }, // 支付结算管理-下游电商结算对账-发票预览下载
  {
    path: 'ecDownInvoiceDownload',
    name: 'ecDownInvoiceDownload',
    meta: {
      title: '发票预览下载',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecDownSettlementMenu/ecDownBillList/ecDownInvoiceDownload');
    }
  }, // 支付结算管理-下游电商结算对账-结算单详情
  {
    path: 'ecDownStatementDetails',
    name: 'ecDownStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecDownSettlementMenu/ecDownBillList/ecDownStatementDetails');
    }
  }, // 支付结算管理-下游电商结算对账-发票物流详情
  {
    path: 'ecDownInvoiceLogisticsDetails',
    name: 'ecDownInvoiceLogisticsDetails',
    meta: {
      title: '发票物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecDownSettlementMenu/ecDownBillList/ecDownInvoiceLogisticsDetails');
    }
  }, // 支付结算管理-三方交易电商结算对账-业务对账
  {
    path: 'ecMatchingSettlementList',
    name: 'ecMatchingSettlementList',
    meta: {
      title: '三方交易电商业务对账',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecMatchingSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecMatchingSettlementMenu/ecMatchingSettlementList/ecMatchingSettlementList');
    }
  }, // 支付结算管理-三方交易电商结算对账-结算单确认页
  {
    path: 'ecMatchingConfirmStatement',
    name: 'ecMatchingConfirmStatement',
    meta: {
      title: '结算单确认页',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecMatchingSettlementMenu/ecMatchingSettlementList/ecMatchingConfirmStatement');
    }
  }, // 支付结算管理-三方交易电商结算对账-结算单列表页
  {
    path: 'ecMatchingBillList',
    name: 'ecMatchingBillList',
    meta: {
      title: '三方交易电商结算单列表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecMatchingBillList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecMatchingSettlementMenu/ecMatchingBillList/ecMatchingBillList');
    }
  }, // 支付结算管理-三方交易电商结算对账-结算单发票核对签收页
  {
    path: 'ecMatchingReceiptOfStatement',
    name: 'ecMatchingReceiptOfStatement',
    meta: {
      title: '结算单发票核对签收页',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecMatchingSettlementMenu/ecMatchingBillList/ecMatchingReceiptOfStatement');
    }
  }, // 支付结算管理-三方交易电商结算对账-发票预览下载
  {
    path: 'ecMatchingInvoiceDownload',
    name: 'ecMatchingInvoiceDownload',
    meta: {
      title: '发票预览下载',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecMatchingSettlementMenu/ecMatchingBillList/ecMatchingInvoiceDownload');
    }
  }, // 支付结算管理-三方交易电商结算对账-结算单详情
  {
    path: 'ecMatchingStatementDetails',
    name: 'ecMatchingStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecMatchingSettlementMenu/ecMatchingBillList/ecMatchingStatementDetails');
    }
  }, // 支付结算管理-三方交易电商结算对账-发票物流详情
  {
    path: 'ecMatchingInvoiceLogisticsDetails',
    name: 'ecMatchingInvoiceLogisticsDetails',
    meta: {
      title: '发票物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecMatchingSettlementMenu/ecMatchingBillList/ecMatchingInvoiceLogisticsDetails');
    }
  }, // 支付结算管理-贸易电商结算对账-业务对账
  {
    path: 'ecTradeSettlementList',
    name: 'ecTradeSettlementList',
    meta: {
      title: '贸易电商业务对账',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecTradeSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecTradeSettlementMenu/ecTradeSettlementList/ecTradeSettlementList');
    }
  }, // 支付结算管理-贸易电商结算对账-结算单确认
  {
    path: 'ecTradeConfirmStatement',
    name: 'ecTradeConfirmStatement',
    meta: {
      title: '贸易电商结算单确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecTradeSettlementMenu/ecTradeSettlementList/ecTradeConfirmStatement');
    }
  }, // 支付结算管理-贸易电商结算对账-结算单列表页
  {
    path: 'ecTradeBillList',
    name: 'ecTradeBillList',
    meta: {
      title: '贸易电商结算单列表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecTradeBillList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecTradeSettlementMenu/ecTradeBillList/ecTradeBillList');
    }
  }, // 支付结算管理-贸易电商结算对账-结算单确认对账
  {
    path: 'ecTradeBilConfirmStatement',
    name: 'ecTradeBilConfirmStatement',
    meta: {
      title: '贸易电商结算单确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecTradeSettlementMenu/ecTradeBillList/ecTradeBilConfirmStatement');
    }
  }, // 支付结算管理-贸易电商结算对账-发票签收
  {
    path: 'ecTradeReceiptOfStatement',
    name: 'ecTradeReceiptOfStatement',
    meta: {
      title: '发票签收',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecTradeSettlementMenu/ecTradeBillList/ecTradeReceiptOfStatement');
    }
  }, // 支付结算管理-贸易电商结算对账-发票预览下载
  {
    path: 'ecTradeInvoiceDownload',
    name: 'ecTradeInvoiceDownload',
    meta: {
      title: '发票预览下载',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecTradeSettlementMenu/ecTradeBillList/ecTradeInvoiceDownload');
    }
  }, // 支付结算管理-贸易电商结算对账-结算单详情
  {
    path: 'ecTradeStatementDetails',
    name: 'ecTradeStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecTradeSettlementMenu/ecTradeBillList/ecTradeStatementDetails');
    }
  }, // 支付结算管理-贸易电商结算对账-发票物流详情
  {
    path: 'ecTradeInvoiceLogisticsDetails',
    name: 'ecTradeInvoiceLogisticsDetails',
    meta: {
      title: '发票物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecTradeSettlementMenu/ecTradeBillList/ecTradeInvoiceLogisticsDetails');
    }
  }, // 下游无协议
  // 支付结算管理-下游无协议结算对账-业务对账
  {
    path: 'unagrDownSettlementList',
    name: 'unagrDownSettlementList',
    meta: {
      title: '下游无协议业务对账',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrDownSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrDownSettlementMenu/unagrDownSettlementList/unagrDownSettlementList');
    }
  }, // 支付结算管理-下游无协议结算对账-结算单确认
  {
    path: 'unagrDownConfirmStatement',
    name: 'unagrDownConfirmStatement',
    meta: {
      title: '下游无协议结算单确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrDownSettlementMenu/unagrDownSettlementList/unagrDownConfirmStatement');
    }
  }, // 支付结算管理-下游无协议结算对账-结算单列表页
  {
    path: 'unagrDownBillList',
    name: 'unagrDownBillList',
    meta: {
      title: '下游无协议结算单',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrDownBillList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrDownSettlementMenu/unagrDownBillList/unagrDownBillList');
    }
  }, // 支付结算管理-下游无协议结算对账-发票邮寄信息
  {
    path: 'unagrDownMailingInformation',
    name: 'unagrDownMailingInformation',
    meta: {
      title: '发票邮寄信息',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrDownSettlementMenu/unagrDownBillList/unagrDownMailingInformation');
    }
  }, // 支付结算管理-下游无协议结算对账-发票预览下载
  {
    path: 'unagrDownInvoiceDownload',
    name: 'unagrDownInvoiceDownload',
    meta: {
      title: '发票预览下载',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrDownSettlementMenu/unagrDownBillList/unagrDownInvoiceDownload');
    }
  }, // 支付结算管理-下游无协议结算对账-结算单详情
  {
    path: 'unagrDownStatementDetails',
    name: 'unagrDownStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrDownSettlementMenu/unagrDownBillList/unagrDownStatementDetails');
    }
  }, // 支付结算管理-下游无协议结算对账-发票物流详情
  {
    path: 'unagrDownInvoiceLogisticsDetails',
    name: 'unagrDownInvoiceLogisticsDetails',
    meta: {
      title: '发票物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrDownSettlementMenu/unagrDownBillList/unagrDownInvoiceLogisticsDetails');
    }
  }, // 支付结算管理-三方交易协议结算对账-业务对账
  {
    path: 'agrMatchingSettlementList',
    name: 'agrMatchingSettlementList',
    meta: {
      title: '业务对账',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrMatchingSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrMatchingSettlementMenu/agrMatchingSettlementList/agrMatchingSettlementList');
    }
  }, // 支付结算管理-三方交易协议结算对账-结算单确认
  {
    path: 'agrMatchingConfirmStatement',
    name: 'agrMatchingConfirmStatement',
    meta: {
      title: '结算单确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrMatchingSettlementMenu/agrMatchingSettlementList/agrMatchingConfirmStatement');
    }
  }, // 支付结算管理-三方交易协议结算对账-结算单列表页
  {
    path: 'agrMatchingBillList',
    name: 'agrMatchingBillList',
    meta: {
      title: '对账单列表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrMatchingBillList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrMatchingSettlementMenu/agrMatchingBillList/agrMatchingBillList');
    }
  }, // 支付结算管理-三方交易协议结算对账-结算单确认对账
  {
    path: 'agrMatchingStaConfirm',
    name: 'agrMatchingStaConfirm',
    meta: {
      title: '结算单确认对账',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrMatchingSettlementMenu/agrMatchingBillList/agrMatchingStaConfirm');
    }
  }, // 支付结算管理-三方交易协议结算对账-结算单发票签收
  {
    path: 'agrMatchingRecStatement',
    name: 'agrMatchingRecStatement',
    meta: {
      title: '结算单发票签收',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrMatchingSettlementMenu/agrMatchingBillList/agrMatchingRecStatement');
    }
  }, // 支付结算管理-三方交易协议结算对账-发票预览下载
  {
    path: 'agrMatchingInvoiceDownload',
    name: 'agrMatchingInvoiceDownload',
    meta: {
      title: '发票预览下载',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrMatchingSettlementMenu/agrMatchingBillList/agrMatchingInvoiceDownload');
    }
  }, // 支付结算管理-三方交易协议结算对账-结算单详情
  {
    path: 'agrMatchingStatementDetails',
    name: 'agrMatchingStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrMatchingSettlementMenu/agrMatchingBillList/agrMatchingStatementDetails');
    }
  }, // 支付结算管理-三方交易协议结算对账-发票物流详情
  {
    path: 'agrMatchingInvLogDetails',
    name: 'agrMatchingInvLogDetails',
    meta: {
      title: '发票物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrMatchingSettlementMenu/agrMatchingBillList/agrMatchingInvLogDetails');
    }
  }, // 支付结算管理-三方交易无协议结算对账-业务对账
  {
    path: 'unagrMatchingSettlementList',
    name: 'unagrMatchingSettlementList',
    meta: {
      title: '三方交易无协议业务对账',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrMatchingSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrMatchingSettlementMenu/unagrMatchingSettlementList/unagrMatchingSettlementList');
    }
  }, // 支付结算管理-三方交易无协议结算对账-结算单确认
  {
    path: 'unagrMatchingConfirmStatement',
    name: 'unagrMatchingConfirmStatement',
    meta: {
      title: '结算单确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrMatchingSettlementMenu/unagrMatchingSettlementList/unagrMatchingConfirmStatement');
    }
  }, // 支付结算管理-三方交易无协议结算对账-结算单列表页
  {
    path: 'unagrMatchingBillList',
    name: 'unagrMatchingBillList',
    meta: {
      title: '三方交易无协议结算单列表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrMatchingBillList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrMatchingSettlementMenu/unagrMatchingBillList/unagrMatchingBillList');
    }
  }, // 支付结算管理-三方交易无协议结算对账-结算单确认对账
  {
    path: 'unagrMatchingStaConfirm',
    name: 'unagrMatchingStaConfirm',
    meta: {
      title: '结算单确认对账',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrMatchingSettlementMenu/unagrMatchingBillList/unagrMatchingStaConfirm');
    }
  }, // 支付结算管理-三方交易无协议结算对账-结算单发票签收
  {
    path: 'unagrMatchingRecStatement',
    name: 'unagrMatchingRecStatement',
    meta: {
      title: '结算单发票签收',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrMatchingSettlementMenu/unagrMatchingBillList/unagrMatchingRecStatement');
    }
  }, // 支付结算管理-三方交易无协议结算对账-发票预览下载
  {
    path: 'unagrMatchingInvoiceDownload',
    name: 'unagrMatchingInvoiceDownload',
    meta: {
      title: '发票预览下载',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrMatchingSettlementMenu/unagrMatchingBillList/unagrMatchingInvoiceDownload');
    }
  }, // 支付结算管理-三方交易无协议结算对账-结算单详情
  {
    path: 'unagrMatchingStatementDetails',
    name: 'unagrMatchingStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrMatchingSettlementMenu/unagrMatchingBillList/unagrMatchingStatementDetails');
    }
  }, // 支付结算管理-三方交易无协议结算对账-发票物流详情
  {
    path: 'unagrMatchingInvLogDetails',
    name: 'unagrMatchingInvLogDetails',
    meta: {
      title: '发票物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrMatchingSettlementMenu/unagrMatchingBillList/unagrMatchingInvLogDetails');
    }
  }, // 支付结算管理-贸易协议结算对账-业务对账
  {
    path: 'agrTradeSettlementList',
    name: 'agrTradeSettlementList',
    meta: {
      title: '贸易协议业务对账',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrTradeSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrTradeSettlementMenu/agrTradeSettlementList/agrTradeSettlementList');
    }
  }, // 支付结算管理-贸易协议结算对账-结算单确认
  {
    path: 'agrTradeConfirmStatement',
    name: 'agrTradeConfirmStatement',
    meta: {
      title: '结算单确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrTradeSettlementMenu/agrTradeSettlementList/agrTradeConfirmStatement');
    }
  }, // 支付结算管理-贸易协议结算对账-结算单列表页
  {
    path: 'agrTradeBillList',
    name: 'agrTradeBillList',
    meta: {
      title: '贸易协议结算单列表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrTradeBillList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrTradeSettlementMenu/agrTradeBillList/agrTradeBillList');
    }
  }, // 支付结算管理-贸易协议结算对账-结算单确认对账
  {
    path: 'agrTradeStaConfirm',
    name: 'agrTradeStaConfirm',
    meta: {
      title: '结算单确认对账',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrTradeSettlementMenu/agrTradeBillList/agrTradeStaConfirm');
    }
  }, // 支付结算管理-贸易协议结算对账-结算单发票签收
  {
    path: 'agrTradeRecStatement',
    name: 'agrTradeRecStatement',
    meta: {
      title: '结算单发票签收',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrTradeSettlementMenu/agrTradeBillList/agrTradeRecStatement');
    }
  }, // 支付结算管理-贸易协议结算对账-发票预览下载
  {
    path: 'agrTradeInvoiceDownload',
    name: 'agrTradeInvoiceDownload',
    meta: {
      title: '发票预览下载',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrTradeSettlementMenu/agrTradeBillList/agrTradeInvoiceDownload');
    }
  }, // 支付结算管理-贸易协议结算对账-结算单详情
  {
    path: 'agrTradeStatementDetails',
    name: 'agrTradeStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrTradeSettlementMenu/agrTradeBillList/agrTradeStatementDetails');
    }
  }, // 支付结算管理-贸易协议结算对账-发票物流详情
  {
    path: 'agrTradeInvLogDetails',
    name: 'agrTradeInvLogDetails',
    meta: {
      title: '发票物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrTradeSettlementMenu/agrTradeBillList/agrTradeInvLogDetails');
    }
  }, // 支付结算管理-贸易无协议结算对账-业务对账
  {
    path: 'unagrTradeSettlementList',
    name: 'unagrTradeSettlementList',
    meta: {
      title: '贸易无协议业务对账',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrTradeSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrTradeSettlementMenu/unagrTradeSettlementList/unagrTradeSettlementList');
    }
  }, // 支付结算管理-贸易无协议结算对账-结算单确认
  {
    path: 'unagrTradeConfirmStatement',
    name: 'unagrTradeConfirmStatement',
    meta: {
      title: '结算单确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrTradeSettlementMenu/unagrTradeSettlementList/unagrTradeConfirmStatement');
    }
  }, // 支付结算管理-贸易无协议结算对账-结算单列表页
  {
    path: 'unagrTradeBillList',
    name: 'unagrTradeBillList',
    meta: {
      title: '贸易无协议结算单列表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrTradeBillList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrTradeSettlementMenu/unagrTradeBillList/unagrTradeBillList');
    }
  }, // 支付结算管理-贸易无协议结算对账-结算单确认对账
  {
    path: 'unagrTradeStaConfirm',
    name: 'unagrTradeStaConfirm',
    meta: {
      title: '结算单确认对账',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrTradeSettlementMenu/unagrTradeBillList/unagrTradeStaConfirm');
    }
  }, // 支付结算管理-贸易无协议结算对账-结算单发票签收
  {
    path: 'unagrTradeRecStatement',
    name: 'unagrTradeRecStatement',
    meta: {
      title: '结算单发票签收',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrTradeSettlementMenu/unagrTradeBillList/unagrTradeRecStatement');
    }
  }, // 支付结算管理-贸易无协议结算对账-发票预览下载
  {
    path: 'unagrTradeInvoiceDownload',
    name: 'unagrTradeInvoiceDownload',
    meta: {
      title: '发票预览下载',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrTradeSettlementMenu/unagrTradeBillList/unagrTradeInvoiceDownload');
    }
  }, // 支付结算管理-贸易无协议结算对账-结算单详情
  {
    path: 'unagrTradeStatementDetails',
    name: 'unagrTradeStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrTradeSettlementMenu/unagrTradeBillList/unagrTradeStatementDetails');
    }
  }, // 支付结算管理-贸易无协议结算对账-发票物流详情
  {
    path: 'unagrTradeInvLogDetails',
    name: 'unagrTradeInvLogDetails',
    meta: {
      title: '发票物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrTradeSettlementMenu/unagrTradeBillList/unagrTradeInvLogDetails');
    }
  }, // 支付结算管理-协议结算对账-结算单列表
  {
    path: 'agrSupSettlementList',
    name: 'agrSupSettlementList',
    meta: {
      title: '协议结算单列表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrSupSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrSettlementMenu/agrSupSettlementList/agrSupSettlementList');
    }
  }, // 支付结算管理-协议结算对账-结算单对账
  {
    path: 'agrSupStaConfirm',
    name: 'agrSupStaConfirm',
    meta: {
      title: '结算单对账',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrSettlementMenu/agrSupSettlementList/agrSupStaConfirm');
    }
  }, // 支付结算管理-协议结算对账-结算单对账
  {
    path: 'finSupStaConfirm',
    name: 'finSupStaConfirm',
    meta: {
      title: '结算单对账',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/finSettlementMenu/finSupSettlementList/finSupStaConfirm.vue');
    }
  }, // 支付结算管理-协议结算对账-导入发票
  {
    path: 'importInvInformation',
    name: 'importInvInformation',
    meta: {
      title: '导入发票',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrSettlementMenu/agrSupSettlementList/importInvInformation');
    }
  }, // 支付结算管理-协议结算对账-导入发票
  {
    path: 'finImportInvInformation',
    name: 'finImportInvInformation',
    meta: {
      title: '导入发票',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/finSettlementMenu/finSupSettlementList/finImportInvInformation.vue');
    }
  }, // 支付结算管理-协议结算对账-结算单详情
  {
    path: 'agrSupStatementDetails',
    name: 'agrSupStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrSettlementMenu/agrSupSettlementList/agrSupStatementDetails');
    }
  }, // 支付结算管理-协议结算对账-结算单详情
  {
    path: 'finSupStatementDetails',
    name: 'finSupStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/finSettlementMenu/finSupSettlementList/finSupStatementDetails.vue');
    }
  }, // 支付结算管理-协议结算对账-物流详情
  {
    path: 'agrSupInvLogDetails',
    name: 'agrSupInvLogDetails',
    meta: {
      title: '物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrSettlementMenu/agrSupSettlementList/agrSupInvLogDetails');
    }
  }, // 支付结算管理-协议结算对账-物流详情（财务中心）
  {
    path: 'finSupInvLogDetails',
    name: 'finSupInvLogDetails',
    meta: {
      title: '物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/finSettlementMenu/finSupSettlementList/finSupInvLogDetails.vue');
    }
  }, // 支付结算管理-无协议结算对账-结算单列表
  {
    path: 'unagrSupSettlementList',
    name: 'unagrSupSettlementList',
    meta: {
      title: '无协议结算单列表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrSupSettlementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrSettlementMenu/unagrSupSettlementList/unagrSupSettlementList');
    }
  }, // 支付结算管理-无协议结算对账-结算单对账
  {
    path: 'unagrSupStaConfirm',
    name: 'unagrSupStaConfirm',
    meta: {
      title: '结算单对账',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrSettlementMenu/unagrSupSettlementList/unagrSupStaConfirm');
    }
  }, // 支付结算管理-无协议结算对账-导入发票
  {
    path: 'unagrimportInvInformation',
    name: 'unagrimportInvInformation',
    meta: {
      title: '导入发票',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrSettlementMenu/unagrSupSettlementList/unagrimportInvInformation');
    }
  }, // 支付结算管理-无协议结算对账-结算单详情
  {
    path: 'unagrSupStatementDetails',
    name: 'unagrSupStatementDetails',
    meta: {
      title: '结算单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrSettlementMenu/unagrSupSettlementList/unagrSupStatementDetails');
    }
  }, // 支付结算管理-无协议结算对账-物流详情
  {
    path: 'unagrSupInvLogDetails',
    name: 'unagrSupInvLogDetails',
    meta: {
      title: '物流详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/unagrSettlementMenu/unagrSupSettlementList/unagrSupInvLogDetails');
    }
  }, {
    path: 'payApply',
    name: 'payApply',
    meta: {
      title: '付款申请',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['payApply'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/payCollectionMenu/payApply/payApply');
    }
  }, // 支付结算管理-收付款管理-付款申请确认
  {
    path: 'payApplyAffirm',
    name: 'payApplyAffirm',
    meta: {
      title: '付款申请确认',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payCollectionMenu/payApply/payApplyAffirm');
    }
  }, // 支付结算管理-收付款管理-付款管理
  {
    path: 'payManager',
    name: 'payManager',
    meta: {
      title: '付款管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['payManager'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/payCollectionMenu/payManager/payManager');
    }
  }, // 支付结算管理-收付款管理-收付款查询
  {
    path: 'collectionQuery',
    name: 'collectionQuery',
    meta: {
      title: '收付款查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['collectionQuery'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/payCollectionMenu/collectionQuery/collectionQuery');
    }
  }, // 支付结算管理-收付款管理-付款申请单详情页面
  {
    path: 'payApplyDetails',
    name: 'payApplyDetails',
    meta: {
      title: '付款申请单详情页面',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payCollectionMenu/payApplyDetails');
    }
  }, // 支付结算管理-支付中心-商户管理
  {
    path: 'payMerchantManagementList',
    name: 'payMerchantManagementList',
    meta: {
      title: '商户管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['payMerchantManagementList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payMerchantManagementList/payMerchantManagementList');
    }
  }, // 支付结算管理-支付中心-商户管理-商户新增/修改页面-商户设置
  {
    path: 'merchaBasicInfoForm',
    name: 'merchaBasicInfoForm',
    meta: {
      title: '商户设置',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payMerchantManagementList/merchaBasicInfoForm/merchaBasicInfoForm');
    }
  }, // 支付结算管理-支付中心-商户管理-商户新增页面-商户基本信息
  {
    path: 'addMerchaBasicInfo',
    name: 'addMerchaBasicInfo',
    meta: {
      title: '商户基本信息',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payMerchantManagementList/payMerchantsAddOrModify/addMerchaBasicInfo');
    }
  }, // 支付结算管理-支付中心-商户管理-商户新增页面-商户收款账户渠道信息
  {
    path: 'addAccountChannelInfo',
    name: 'addAccountChannelInfo',
    meta: {
      title: '商户收款账户渠道信息',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payMerchantManagementList/payMerchantsAddOrModify/addAccountChannelInfo');
    }
  }, // 支付结算管理-支付中心-商户管理-商户管理新增-通用支付结算配置
  {
    path: 'addPaymentConfigure',
    name: 'addPaymentConfigure',
    meta: {
      title: '通用支付结算配置',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payMerchantManagementList/payMerchantsAddOrModify/addPaymentConfigure');
    }
  }, // 支付结算管理-支付中心-商户管理-商户管理新增-例外情况
  {
    path: 'addExceptions',
    name: 'addExceptions',
    meta: {
      title: '例外情况',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payMerchantManagementList/payMerchantsAddOrModify/addExceptions');
    }
  }, // 支付结算管理-支付中心-商户管理-商户管理新增-例外情况-添加/修改支付配置例外页面
  {
    path: 'addModPayConfigEx',
    name: 'addModPayConfigEx',
    meta: {
      title: '添加/修改支付配置例外页面',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payMerchantManagementList/payMerchantsAddOrModify/addModPayConfigEx');
    }
  }, // 支付结算管理-支付中心-商户管理-商户管理新增-例外情况-添加/修改结算模式配置例外页面
  {
    path: 'addModSettleConfigEx',
    name: 'addModSettleConfigEx',
    meta: {
      title: '添加/修改结算模式配置例外页面',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payMerchantManagementList/payMerchantsAddOrModify/addModSettleConfigEx');
    }
  }, // 支付结算管理-支付中心-商户管理-商户管理新增-例外情况-添加/修改结算模式配置例外页面-选择合同
  {
    path: 'chooseContract',
    name: 'chooseContract',
    meta: {
      title: '选择合同',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payMerchantManagementList/payMerchantsAddOrModify/chooseContract');
    }
  }, // 支付结算管理-支付中心-商户管理-商户详情页面
  {
    path: 'merchantDetails',
    name: 'merchantDetails',
    meta: {
      title: '商户详情页面',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payMerchantManagementList/merchantDetails');
    }
  }, // 支付结算管理-支付中心-商户管理-基础配置管理
  {
    path: 'payBasicConfigList',
    name: 'payBasicConfigList',
    meta: {
      title: '基础配置管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['payBasicConfigList']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payBasicConfigManagement/payBasicConfigList');
    }
  }, // 支付结算管理-支付中心-商户管理-基础配置管理-收银台新增-收银台基本信息
  {
    path: 'addModCashierBasicInfo',
    name: 'addModCashierBasicInfo',
    meta: {
      title: '收银台基本信息',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payBasicConfigManagement/cashierAddOrModify/addModCashierBasicInfo');
    }
  }, // 支付结算管理-支付中心-商户管理-基础配置管理-收银台新增-收银台支付方式
  {
    path: 'addModCashierPayment',
    name: 'addModCashierPayment',
    meta: {
      title: '收银台支付方式',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payBasicConfigManagement/cashierAddOrModify/addModCashierPayment');
    }
  }, // 支付结算管理-支付中心-商户管理-基础配置管理-支付机构详情页
  {
    path: 'payInstitutionDetail',
    name: 'payInstitutionDetail',
    meta: {
      title: '支付机构详情页',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payBasicConfigManagement/payInstitutionDetail');
    }
  }, // 支付结算管理-支付中心-商户管理-基础配置管理-支付机构图标管理页面
  {
    path: 'payIconManagement',
    name: 'payIconManagement',
    meta: {
      title: '支付机构图标管理页面',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payBasicConfigManagement/payIconManagement');
    }
  }, // 支付结算管理-支付中心-商户管理-基础配置管理-收银台详情
  {
    path: 'cashierDetail',
    name: 'cashierDetail',
    meta: {
      title: '收银台详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payBasicConfigManagement/cashierDetail');
    }
  }, // 支付结算管理-支付结算审批-付款申请单审批
  {
    path: 'payApplicationAppro',
    name: 'payApplicationAppro',
    meta: {
      title: '付款申请单审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['payApplicationAppro'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/paySettlementApproMenu/payApplicationAppro/payApplicationAppro');
    }
  }, // 支付结算管理-支付结算审批-付款申请单审批页面
  {
    path: 'payApplicationApprotal',
    name: 'payApplicationApprotal',
    meta: {
      title: '付款申请单审批页面',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/paySettlementApproMenu/payApplicationAppro/payApplicationApprotal');
    }
  }, // 支付结算管理-支付结算查询-发票查询
  {
    path: 'invoiceQuery',
    name: 'invoiceQuery',
    meta: {
      title: '发票查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['invoiceQuery'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/paySettlementQueryMenu/invoiceQuery/invoiceQuery');
    }
  }, // 支付结算管理-支付结算查询-库存查询
  {
    path: 'repertoryQuery',
    name: 'repertoryQuery',
    meta: {
      title: '库存查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['repertoryQuery'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/paySettlementQueryMenu/repertoryQuery/repertoryQuery');
    }
  }, // 支付结算管理-支付结算查询-在线支付交易记录查询
  {
    path: 'onlinePayDealRecord',
    name: 'onlinePayDealRecord',
    meta: {
      title: '在线支付交易记录查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['onlinePayDealRecord'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/paySettlementQueryMenu/onlinePayDealRecord/onlinePayDealRecord');
    }
  }, // 支付结算管理-出入库管理-入库管理
  {
    path: 'inWareHouseManager',
    name: 'inWareHouseManager',
    meta: {
      title: '入库管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['inWareHouseManager'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/inOutWarehouseMenu/inWareHouseManager/inWareHouseManager');
    }
  }, // 支付结算管理-出入库管理-入库详情页
  {
    path: 'inWareHouseDetails',
    name: 'inWareHouseDetails',
    meta: {
      title: '入库管理详情页',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/inOutWarehouseMenu/inWareHouseManager/inWareHouseDetails');
    }
  }, // 支付结算管理-出入库管理-出库管理
  {
    path: 'outWareHouseManager',
    name: 'outWareHouseManager',
    meta: {
      title: '出库管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['outWareHouseManager'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/inOutWarehouseMenu/outWareHouseManager/outWareHouseManager');
    }
  }, // 支付结算管理-出入库管理-出库详情页
  {
    path: 'outWareHouseDetails',
    name: 'outWareHouseDetails',
    meta: {
      title: '出库管理详情页',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/inOutWarehouseMenu/outWareHouseManager/outWareHouseDetails');
    }
  }, // 支付结算管理-发票邮寄-发票邮寄
  {
    path: 'notInvoiceMail',
    name: 'notInvoiceMail',
    meta: {
      title: '发票邮寄',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['notInvoiceMail'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/invoiceMailMenu/notInvoiceMail/notInvoiceMail');
    }
  }, // 支付结算管理-成交服务费管理-成交服务费管理
  {
    path: 'dealServCostManage',
    name: 'dealServCostManage',
    meta: {
      title: '成交服务费管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['dealServCostManage'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/dealServCostMenu/dealServCostManage/dealServCostManage.vue');
    }
  }, // 支付结算管理-成交服务费管理-成交服务费管理_邮寄录入信息
  {
    path: 'writeEMailInfo',
    name: 'writeEMailInfo',
    meta: {
      title: '邮寄录入信息页面',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/dealServCostMenu/dealServCostManage/writeEMailInfo.vue');
    }
  }, // 支付结算管理-成交服务费管理-成交服务费结算单详情页
  {
    path: 'dealServCostDetails',
    name: 'dealServCostDetails',
    meta: {
      title: '成交服务费结算单详情页',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/dealServCostMenu/dealServCostManage/dealServCostDetails.vue');
    }
  }, // 支付结算管理-收付款管理-付款申请待确认
  {
    path: 'payApplyalready',
    name: 'payApplyalready',
    meta: {
      title: '付款管理付款待确认',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payCollectionMenu/payManager/payApplyalready');
    }
  }, // 支付结算管理-平台使用费管理-平台使用费管理
  {
    path: 'platformUseCostManage',
    name: 'platformUseCostManage',
    meta: {
      title: '平台使用费管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['platformUseCostManage'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/platformUseCostMenu/platformUseCostManage/platformUseCostManage.vue');
    }
  }, // 支付结算管理-平台使用费管理-平台使用费管理邮寄录入页面
  {
    path: 'platformUseCostInfo',
    name: 'platformUseCostInfo',
    meta: {
      title: '平台使用费管理',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/platformUseCostMenu/platformUseCostManage/platformUseCostInfo.vue');
    }
  }, // 支付结算管理-平台使用费管理-平台使用费管理结算单详情页
  {
    path: 'platformUseCostDetails',
    name: 'platformUseCostDetails',
    meta: {
      title: '平台使用费管理',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/platformUseCostMenu/platformUseCostManage/platformUseCostDetails.vue');
    }
  }, // 支付结算管理-成交服务费管理-成交服务费结算单提交页面
  {
    path: 'dealServCostUpload',
    name: 'dealServCostUpload',
    meta: {
      title: '成交服务费结算单提交页面',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/dealServCostMenu/dealServCostManage/dealServCostUpload.vue');
    }
  }, // 支付结算管理-成交服务费管理-预览
  {
    path: 'previewServiceChargeInvoice',
    name: 'previewServiceChargeInvoice',
    meta: {
      title: '成交服务费结算单提交页面',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/platformUseCostMenu/platformUseCostManage/components/previewServiceChargeInvoice.vue');
    }
  }, // 支付结算管理-成交服务费管理-成交服务费付款申请单确认页面
  {
    path: 'dealApplyAffirm',
    name: 'dealApplyAffirm',
    meta: {
      title: '成交服务费付款申请单确认页面',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/dealServCostMenu/dealServCostManage/dealApplyAffirm.vue');
    }
  }, // 支付结算管理-平台使用费管理-平台使用费结算单申请开票页面
  {
    path: 'platformUseCostUpload',
    name: 'platformUseCostUpload',
    meta: {
      title: '平台使用费结算单申请开票页面',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/platformUseCostMenu/platformUseCostManage/platformUseCostUpload.vue');
    }
  }, // 支付结算管理-外部系统对账-在线支付系统对账
  {
    path: 'onlinePaymentRecon',
    name: 'onlinePaymentRecon',
    meta: {
      title: '在线支付系统对账',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['onlinePaymentRecon'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/externalSysReconMenu/onlinePaymentRecon/onlinePaymentRecon');
    }
  }, // 1menu支付结算管理 / 2menu支付结算查询 / 3menu发票查询 发票预览下载
  {
    path: 'invoiceQueryDownload',
    name: 'invoiceQueryDownload',
    meta: {
      title: '发票查询-发票预览',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/paySettlementQueryMenu/invoiceQuery/Model/invoiceQueryDownload');
    }
  }, // 1menu支付结算管理 / 2menu收付款管理 / 3menu收款管理-TBC（待完成手动来款匹配）
  {
    path: 'collectionManagerList',
    name: 'collectionManagerList',
    meta: {
      title: '收款管理-TBC',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['collectionManagerList'] // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/payCollectionMenu/collectionManager/collectionManagerList');
    }
  }, // 商户管理
  {
    path: 'newPayMerchantManagementList',
    name: 'newPayMerchantManagementList',
    meta: {
      title: '商户管理',
      cache: true // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payMerchantManagementList/newPayMerchantManagementList.vue');
    }
  }, // 商户管理
  {
    path: 'agrTradeStatementCheck',
    name: 'agrTradeStatementCheck',
    meta: {
      title: '供应商对账',
      cache: true // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrSettlementMenu/agrSupSettlementList/agrTradeStatementCheck.vue');
    }
  }, // 商户管理
  {
    path: 'finTradeStatementCheck',
    name: 'finTradeStatementCheck',
    meta: {
      title: '供应商对账',
      cache: true // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/finSettlementMenu/finSupSettlementList/finTradeStatementCheck.vue');
    }
  }, // 商户管理
  {
    path: 'dealImportInvInformation',
    name: 'dealImportInvInformation',
    meta: {
      title: '导入发票信息',
      cache: true // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/dealServCostMenu/dealServCostManage/dealImportInvInformation.vue');
    }
  }, // 三方类对账设置
  {
    path: 'thirdPayMerchantManagementList',
    name: 'thirdPayMerchantManagementList',
    meta: {
      title: '三方类对账设置',
      cache: true // hidden: true

    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payMerchantManagementList/thirdPayMerchantManagementList.vue');
    }
  }, // 商户管理
  {
    path: 'thirdMerchaBasicInfoForm',
    name: 'thirdMerchaBasicInfoForm',
    meta: {
      title: '新增例外',
      cache: true,
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/payMentCenterMenu/payMerchantManagementList/merchaBasicInfoForm/thirdMerchaBasicInfoForm.vue');
    }
  }, // 确认对账
  {
    path: 'newEcTradeBilConfirmStatement',
    name: 'newEcTradeBilConfirmStatement',
    meta: {
      title: '确认对账',
      cache: true,
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ecTradeSettlementMenu/ecTradeBillList/newEcTradeBilConfirmStatement.vue');
    }
  }, // 确认对账
  {
    path: 'newAgrMatchingStatementDetails',
    name: 'newAgrMatchingStatementDetails',
    meta: {
      title: '对账详情',
      cache: true,
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/agrTradeSettlementMenu/agrTradeBillList/newAgrMatchingStatementDetails.vue');
    }
  }, // 确认对账
  {
    path: 'finTradeBilConfirmStatement',
    name: 'finTradeBilConfirmStatement',
    meta: {
      title: '确认对账',
      cache: true,
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/finMatchingSettlementMenu/finMatchingSettlementMenu/finTradeBilConfirmStatement.vue');
    }
  }, // 签收发票
  {
    path: 'finTradeReceiptOfStatement',
    name: 'finTradeReceiptOfStatement',
    meta: {
      title: '签收发票',
      cache: true,
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/finMatchingSettlementMenu/finMatchingSettlementMenu/finTradeReceiptOfStatement.vue');
    }
  }, // 对账详情
  {
    path: 'finTradeStatementDetails',
    name: 'finTradeStatementDetails',
    meta: {
      title: '对账详情',
      cache: true,
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/finMatchingSettlementMenu/finMatchingSettlementMenu/finTradeStatementDetails.vue');
    }
  }, // 业务对账
  {
    path: 'finMatchingConfirmStatement',
    name: 'finMatchingConfirmStatement',
    meta: {
      title: '业务对账',
      cache: true,
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/finMatchingSettlementListMenu/finMatchingConfirmStatement.vue');
    }
  }, // 对账单
  {
    path: 'finMatchingBillList',
    name: 'finMatchingBillList',
    meta: {
      title: '对账单',
      cache: true,
      hidden: false
    },
    component: function component() {
      return import('@/pages/paySettlementModule/finMatchingSettlementMenu/finMatchingSettlementMenu/finMatchingBillList.vue');
    }
  }, // 对账单
  {
    path: 'newFinMatchingBillList',
    name: 'newFinMatchingBillList',
    meta: {
      title: '对账单',
      cache: true,
      hidden: false
    },
    component: function component() {
      return import('@/pages/paySettlementModule/finMatchingSettlementMenu/finMatchingSettlementMenu/finMatchingBillList.vue');
    }
  }, // 对账单
  {
    path: 'finMatchingSettlementList',
    name: 'finMatchingSettlementList',
    meta: {
      title: '业务对账',
      cache: true,
      hidden: false
    },
    component: function component() {
      return import('@/pages/paySettlementModule/finMatchingSettlementListMenu/finMatchingSettlementList.vue');
    }
  }, // 对账单
  {
    path: 'finSupSettlementList',
    name: 'finSupSettlementList',
    meta: {
      title: '对账单',
      cache: true,
      hidden: false
    },
    component: function component() {
      return import('@/pages/paySettlementModule/finSettlementMenu/finSupSettlementList/finSupSettlementList.vue');
    }
  }, // 应收台账管理
  {
    path: 'collectLedger',
    name: 'collectLedger',
    meta: {
      title: '应收台账管理',
      // cache: true,
      hidden: false
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ledgerMenu/collectLedger.vue');
    }
  }, // 应付台账管理
  {
    path: 'payLedger',
    name: 'payLedger',
    meta: {
      title: '应付台账管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['payLedger']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ledgerMenu/payLedger.vue');
    }
  }, // 应收台账详情
  {
    path: 'collectLedgerDetail',
    name: 'collectLedgerDetail',
    meta: {
      title: '应收台账详情',
      cache: false,
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ledgerMenu/collectLedgerDetail.vue');
    }
  }, // 应付台账详情
  {
    path: 'payLedgerDetail',
    name: 'payLedgerDetail',
    meta: {
      title: '应付台账详情',
      cache: false,
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ledgerMenu/payLedgerDetail.vue');
    }
  }, // 实付台账管理
  {
    path: 'actualPayAccounts',
    name: 'actualPayAccounts',
    meta: {
      title: '应付台账管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['actualPayAccounts']
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ledgerMenu/actualPayAccounts/actualPayAccounts.vue');
    }
  }, // 实付台账详情
  {
    path: 'actualPayAccountsDetail',
    name: 'actualPayAccountsDetail',
    meta: {
      title: '实付台账详情',
      cache: false,
      hidden: true
    },
    component: function component() {
      return import('@/pages/paySettlementModule/ledgerMenu/actualPayAccounts/actualPayAccountsDetail.vue');
    }
  }]
};